class QuickshipSwatches extends HTMLElement {
  constructor() {
    super();
    this.productJsonElement = this.querySelector('#quickship-product-json');
    this.mainProductVariantsJsonElement = document.querySelector('[data-variant-json]');

    this.product = JSON.parse(this.productJsonElement.textContent);
    this.mainProductVariants = JSON.parse(this.mainProductVariantsJsonElement.textContent);

    this.swatchesElements = this.querySelectorAll('input[name="quickship-variants"]');
    this.productAddons = document.querySelector('.product-addons');

    this.productSection = theme.sections.instances.find(section => section.type === "product");

    this.initEvents();
    this.initSlider();
  }

  initEvents() {
    this.handleSwatchChange();
  }

  initSlider() {
    const $owl = $('.quickship-items.owl-carousel')
    $owl.owlCarousel({
      loop: false,
      margin: 5,
      dots: true,
      nav: true,
      autoplay: false,
      stagePadding: 10,
      responsive: {
        0: {
          items: 1.2,
          autoWidth: true,
          dots: true,
        },
        600: {
          items: 2,
          dots: true,
        },
        1000: { // min-width: 1000
          items: 2 // show 2 items
          // items: 3
        }
      }
    });

    $(".owl-prev").html(`<div class="option-arrow-left">
      <img src="${window._icons.arrowLeft}" alt="">
    </div>`);

    $(".owl-next").html(`<div class="option-arrow-right">
      <img src="${window._icons.arrowRight}" alt="">
    </div>`);

    // $owl.on("wheel", ".owl-stage", function (e) {
    //   const oE = e.originalEvent;

    //   // Check if horizontal movement is stronger than vertical
    //   if (Math.abs(oE.deltaX) > Math.abs(oE.deltaY)) {
    //     e.preventDefault();

    //     if (oE.deltaX > 0) {
    //       $owl.trigger("next.owl");
    //     } else {
    //       $owl.trigger("prev.owl");
    //     }
    //   }
    // });

    let scrollAccumulator = 0;
    const threshold = 100; // how much deltaX movement before changing slide

    $owl.on("wheel", ".owl-stage", function (e) {
      const oE = e.originalEvent;

      // Only consider horizontal gestures stronger than vertical
      if (Math.abs(oE.deltaX) > Math.abs(oE.deltaY)) {
        e.preventDefault();
        e.stopPropagation();

        scrollAccumulator += oE.deltaX;

        if (scrollAccumulator > threshold) {
          $owl.trigger("next.owl");
          scrollAccumulator = 0;
        } else if (scrollAccumulator < -threshold) {
          $owl.trigger("prev.owl");
          scrollAccumulator = 0;
        }
      }
    });
  }

  handleSwatchChange() {
    this.swatchesElements.forEach(swatch => {
      swatch.addEventListener('click', (e) => {
        const variant = this.product.variants.find(variant => variant.id == swatch.dataset.id);
        if (!this.productSection) return;

        const _ps = this.productSection.variants;
        _ps._updateMasterSelect(variant);
        _ps._updatePrice(variant);
        _ps._updateUnitPrice(variant);
        _ps._updateSKU(variant);
        _ps._selectedVariantDimensionsAndLeadtime(variant);
        this.productSection.updateCartButton({
          detail: { variant }
        });

        const mainVariant = this.mainProductVariants.find(v => `${v.sku}-ADH` === variant.sku || v.sku === variant.sku);
        if (!mainVariant?.featured_image) return;
        _ps._updateImages(mainVariant);
      });
    });
  }

  set() {
    this.swatchesElements.forEach((swatch) => {
      if (swatch.checked) {
        swatch.dispatchEvent(new Event('click'));
      }
    });

    // hide add-ons
    if (this.productAddons) {
      this.productAddons.classList.add('hidden');
    }
  }

  reset() {
    // make add-ons visible
    if (this.productAddons) {
      this.productAddons.classList.remove('hidden');
    }

    // the rest of it
    const _ps = this.productSection.variants;
    _ps.currentVariant = null;
    const currentlySelectedValues = (_ps.currentlySelectedValues = _ps._getCurrentOptions());
    let variant = _ps._getVariantFromOptions();

    if (!variant && _ps.variants?.length === 1) {
      variant = _ps.variants[0];
      if (variant?.option1) {
        currentlySelectedValues.push({ value: variant.option1, index: 'option1' });
      }
      if (variant?.option2) {
        currentlySelectedValues.push({ value: variant.option2, index: 'option2' });
      }
      if (variant?.option3) {
        currentlySelectedValues.push({ value: variant.option3, index: 'option3' });
      }
    }

    const detail = {
      variant,
      currentlySelectedValues
    };

    _ps.container.dispatchEvent(
      new CustomEvent("variantChange", { detail })
    );
    document.dispatchEvent(new CustomEvent("variant:change", { detail }));

    if (!variant) {
      _ps._linkVariantOptions();
      _ps._updatePrice();
      _ps._updateSKU(null);
      _ps._selectedVariantDimensionsAndLeadtime(null);
      return;
    }

    _ps._updateMasterSelect(variant);
    _ps._updateImages(variant);
    _ps._updatePrice(variant);
    _ps._updateUnitPrice(variant);
    _ps._updateSKU(variant);
    _ps.updateDrwStock(variant);
    _ps._updateInventory(variant);
    _ps.currentVariant = variant;

    if (_ps.enableHistoryState) {
      _ps._updateHistoryState(variant);
    }

    _ps._selectedVariantDimensionsAndLeadtime(variant);
    _ps._linkVariantOptions();
  }
}

customElements.define('quickship-swatches', QuickshipSwatches);

class Tabs extends HTMLElement {
  constructor() {
    super();
    this.initSelectors();
    this.initEvents();
  }

  initSelectors() {
    this.selectors = {
      tabSelectors: 'ul>li>a',
      activeTabSelectors: 'ul>li>a.active',
      tabContentSelectors: '.tabs-content>*'
    };
    this.elements = {
      tabSelectors: this.querySelectorAll(this.selectors.tabSelectors),
      tabContentSelectors: this.querySelectorAll(this.selectors.tabContentSelectors)
    }
  }

  initEvents() {
    this.elements.tabSelectors.forEach((tab) => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();

        // de-select the currently selected tab
        this.elements.tabSelectors.forEach((t) => { t.classList.remove('active') });
        this.elements.tabContentSelectors.forEach((t) => t.classList.remove('active'));

        // make the current tab active
        tab.classList.add('active');
        this.querySelector(this.selectors.tabContentSelectors + tab.getAttribute('href')).classList.add('active');

        const quickshipSwatches = document.querySelector('quickship-swatches');
        if (!quickshipSwatches) return;
        if (tab.getAttribute('href') === '#tab-regular--product_options') {
          quickshipSwatches.reset();
        } else {
          quickshipSwatches.set();
        }
      })
    });

  }
}

customElements.define('tabs-element', Tabs);
